import { render, staticRenderFns } from "./CourtsList.vue?vue&type=template&id=5210975d&"
import script from "./CourtsList.vue?vue&type=script&lang=js&"
export * from "./CourtsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports